<template>
    <sa-page-layout ref="SaplPostiLettoPianiView" :btnCloseVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <rsa-configurazione-profili-lis-view-component :showModalLoading="showModalLoading" @errorRestCall="onError" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-configurazione-profili-lis-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneProfiliLisViewComponent from "../components/RsaConfigurazioneProfiliLisViewComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneProfiliLisViewComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsaprofililis",
            linkback: "/configurazioni/rsaconfigurazioneprofililis",
            jsonData: {},
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
        onError(errorData) {
            let me = this;
            me.$refs.SaplPostiLettoPianiView.showModalError(errorData);
        },
    },
};
</script>

<style></style>
